import { Pipe, PipeTransform } from '@angular/core';
import { DirectPlan } from '../../models/direct-subscription.interface';

@Pipe({
  standalone: false,
  name: 'directSubscriptionDescriptionFromKey',
})
export class DirectSubscriptionDescriptionFromKeyPipe implements PipeTransform {
  FRIENDLY_STATUSES = {
    [DirectPlan.Premium]: 'Direct Premium',
    [DirectPlan.Basic]: 'Direct Basic',
    [DirectPlan.Lite]: 'Direct Lite',
  };

  transform(planKey: DirectPlan): string {
    return this.FRIENDLY_STATUSES[planKey] ?? 'Unknown';
  }
}
